"use client";

import { useColorMode } from "@chakra-ui/react";
import { useEffect } from "react";

// Chakra's setColorMode only updates its own state + localStorage; it doesn't
// flip Tailwind's .dark class on <html>, which drives every dark: variant in
// the app. Any component that hosts a toggle calls this so the class stays
// in sync with colorMode.
export function useSyncTailwindDarkClass() {
  const { colorMode } = useColorMode();

  useEffect(() => {
    document.documentElement.classList.toggle("dark", colorMode === "dark");
  }, [colorMode]);
}
